import slideUp from './slideUp'
import slideDown from './slideDown'

export default function slideToggle(target, duration = 500) {
    return window.getComputedStyle(target).display === 'none' ? slideUp(target, duration) : slideDown(target, duration);
};